<script>
import axios from 'axios';
import { consultingApiUrl, consultingApiKey } from '../variables';
import LoadIndicator from '@/components/LoadIndicator';
import ConversationItem from '@/components/consulting/ConversationItem';
import ConversationAnswerForm from '@/components/consulting/ConversationAnswerForm';
import moment from 'moment';

export default {
  name: 'ConversationPage',
  components: {
    LoadIndicator,
    ConversationItem,
    ConversationAnswerForm
  },
  data() {
    return {
      data: null,
      isLoading: true,
      error: null,
    }
  },
  mounted() {
    this.$store.dispatch('setSiteHeaderOpaque');
    this.$store.dispatch('showSiteFooter');
    this.init(this.$route.params.conversationId);
  },
  methods: {
    init(id) {
      axios
      .get(
        `${consultingApiUrl}/conversations/${id}`, 
        {
          headers: {
            Authorization: `Bearer ${consultingApiKey}`
          }
        })
        .then(this.onDataLoaded)
        .catch(() => this.onError());
    },
    onDataLoaded(response) {
      this.data = response.data[0];
      this.isLoading = false;
    },
    onError() {
      this.isLoading = false;
      this.error = 'Error';
    },
    fomratDate(input) {
      const date = new Date(input);
      return moment(date).format('dddd, Do MMMM YYYY, H:mm');
    }
  },
  computed: {
    routerKey() {
      return this.$route.path;
    }
  }
};
</script>

<template>
  <section class="conversation-page">
    <div class="conversation-page__wrapper">
        <h1 class="conversation-page__title page-title">
          {{ $t('consultingConversation.conversationPageTitle') }}
        </h1>
        <p class="conversation-page__lead page-lead">
          {{ $t('consultingConversation.conversationPageLead') }}
        </p>

        <div class="conversation-page__conversation">
          <div v-if="!isLoading && data">
            <div class="conversation__item" v-for="item in data.conversation_items" v-bind:key="item.id">
              <conversation-item v-bind:data="item" />
            </div>
          <conversation-answer-form v-bind:conversation-id="data.id" />
          </div>
          <p class="conversation__error" v-if="error && !isLoading">{{ this.error }}</p>
          <load-indicator v-if="isLoading" />
        </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.conversation-page {
  @include page;
}

.conversation-page__wrapper {
  @include container-narrow;
}
</style>
